import { useQueryWithBoundary } from '@/shared/lib/query';
import { tagKeys } from '@/shared/lib/query/queryKeys';

import { getTagCategoryDetailApi } from '@/features/tags/api';

type UseTagCategoryDetailParams = {
  categoryName: string;
};

export const useTagCategoryDetail = ({ categoryName }: UseTagCategoryDetailParams) => {
  return useQueryWithBoundary({
    queryKey: tagKeys.categoryDetail(categoryName),
    queryFn: () => getTagCategoryDetailApi(categoryName),
    enabled: !!categoryName,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
};
